import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("pageState");

export default {
  computed: {
    ...mapState(["fullHeight", "activeTab"])
  },
  methods: {
    ...mapMutations(["fullHeightOn", "fullHeightOff", "setActiveTab"])
  }
};
